import { fetch } from '@atlassian/eoc-fetch';

import { type SidebarRightsResponse, type Team } from '../../common/types';

export const getTeamByIdEndpoint = (teamId: string): Promise<Team> =>
	fetch<Team>(`/v1/teams/${teamId}?includeImageUrls=true`);

export const getSidebarRightsEndpoint = (teamId: string): Promise<SidebarRightsResponse> => {
	return fetch<SidebarRightsResponse>(`/v1/teams/${teamId}/menu-rights`);
};
